export default "__VITE_ASSET__1103573d__"